export default __webpack_public_path__ + "static/media/gallery_13.e728c56f.jpg";